// TODO: types should come from backend
export const quoteTypes: { [key: string]: string } = {
  joke: 'Joke',
  saying: 'Saying'
};
